import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICoreAuthorizationDTO } from '@app/core/model';
import { SharedAuthorizationService } from '@app/shared/services/shared-authorization.service';
import { ShellService } from '@mynexus/mfe-core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationHHService extends SharedAuthorizationService {
  constructor(
    http: HttpClient,
    shellService: ShellService,
  ) {
    super(http, shellService, 'HH');
  }

  override getAuthorization(tenantId: string, authorizationByProductId: string): Observable<object> {
    return this.http.get<object>(`${this.API_URL}/Search/SearchAuthorizationByAuthorizationNumber/${tenantId}/${authorizationByProductId}`);
  }

  mapAuthorizationDTO(authorizationDto: object): ICoreAuthorizationDTO {
    return {
      authorizationId: authorizationDto['authorizationId'],
      authorizationNumber: authorizationDto['authorizationNumber'],
      authorizationStatus: authorizationDto['authorizationStatus'],
      createdBy: authorizationDto['createdBy'],
      createdOn: authorizationDto['createdOn'],
      effectiveFromDate: authorizationDto['effectiveFromDate'],
      effectiveToDate: authorizationDto['effectiveToDate'],
      productId: authorizationDto['productId'],
      streamData: {
        productName: 'HH',
      },
      urgency: authorizationDto['urgency']
    };
  }
}
